module.exports = __webpack_public_path__ + "img/title3_1.15b01d7d.png";